import { request } from "../client";

import type {
  PronunciationConfiguration,
  PronunciationText,
  PronunciationRequest,
  PronunciationAssessment,
  PronunciationHistory,
  PronunciationAttempt,
  PronunciationProgress,
} from "@lingoshade/domain";

export function createPronunciationEndpoints(baseUrl: string): {
  getConfiguration: (
    token?: string | null,
  ) => Promise<PronunciationConfiguration>;
  getText: (
    textId: string,
    token?: string | null,
  ) => Promise<PronunciationText>;
  assess: (
    input: PronunciationRequest,
    token?: string | null,
    timeoutMs?: number,
  ) => Promise<PronunciationAssessment>;
  getHistory: (
    query: { textId?: string; cursor?: string },
    token?: string | null,
  ) => Promise<PronunciationHistory>;
  getAttempt: (
    id: string,
    token?: string | null,
  ) => Promise<PronunciationAttempt>;
  getProgress: (
    query: { textId: string; start?: number; end?: number },
    token?: string | null,
  ) => Promise<PronunciationProgress>;
} {
  return {
    getAttempt(id, token): Promise<PronunciationAttempt> {
      return request(
        baseUrl,
        `/pronunciation/history/${encodeURIComponent(id)}`,
        { token },
      );
    },
    getProgress(query, token): Promise<PronunciationProgress> {
      return request(baseUrl, "/pronunciation/progress", { query, token });
    },
    getConfiguration(token): Promise<PronunciationConfiguration> {
      return request(baseUrl, "/pronunciation/config", { token });
    },
    getText(textId, token): Promise<PronunciationText> {
      return request(
        baseUrl,
        `/pronunciation/texts/${encodeURIComponent(textId)}`,
        { token },
      );
    },
    assess(input, token, timeoutMs): Promise<PronunciationAssessment> {
      return request(baseUrl, "/pronunciation/assess", {
        method: "POST",
        body: input,
        timeoutMs,
        token,
      });
    },
    getHistory(query, token): Promise<PronunciationHistory> {
      return request(baseUrl, "/pronunciation/history", { query, token });
    },
  };
}
